import { ConfigProvider, message, theme } from 'antd';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import colors from '../scss/variables/colors.module.scss';
import { getTheme } from 'helpers/getTheme';
import { setMessageApi } from 'store/slices/windowStateSlice';

interface Props {
  children?: React.ReactNode;
}

const ThemeProvider: React.FC<Props> = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const { isDarkMode } = useAppSelector((store) => store.windowState);
  
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(setMessageApi(messageApi));
  }, [])

  return (
    <ConfigProvider theme={{
      algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      token: {
        colorPrimary: colors.primary100,
        colorBgTextActive: isDarkMode ? colors.hover100dark : colors.hover100,
        colorFillAlter: isDarkMode ? colors.hover100dark : colors.hover100,
        colorBgLayout: isDarkMode ? colors.black : colors.verylightgrey,
        colorBgTextHover: isDarkMode ? colors.activegreydark : colors.activegrey,
        colorBgMask: isDarkMode ? 'rgba(70, 70, 70, 0.45)' : 'rgba(0,0,0,0.45)',
        // для приведения кнопки reset в фильтрах таблицы к единообразию
        colorLink: colors.primarytransparent,
        colorLinkHover: colors.primary100,
      },
      components: {
        Tabs: {
          colorBgContainer: isDarkMode ? colors.darkBackground : colors.white,
          colorBgTextActive: isDarkMode ? colors.black : colors.verylightgrey,
          colorBgTextHover: isDarkMode ? colors.black : colors.verylightgrey,
          colorFillAlter: isDarkMode ? colors.black : colors.verylightgrey,
        },
        Table: {
          headerBorderRadius: 0,
          headerBg: isDarkMode ? colors.activegreydark : colors.activegrey,
          rowHoverBg: isDarkMode ? colors.activegreydark : colors.hover200,
          bodySortBg: isDarkMode ? colors.activegreydark : colors.white,
          motion: false,
          algorithm: true, // обязательно, иначе motion:false не применится
        },
        Collapse:{
          headerBg: isDarkMode ? colors.darkBackground : colors.white,
          colorBorder: isDarkMode ? colors.borderColorDark : colors.borderColor,
        },
        Modal: {
          contentBg: isDarkMode ? colors.darkBackground : colors.white,
          headerBg:  isDarkMode ? colors.darkBackground : colors.white,
        },
        Tree: {
          nodeSelectedBg: isDarkMode ? colors.hover100dark : colors.hover100,
        },
        Message: {
          contentBg: isDarkMode ? colors.borderColorDark : colors.white,
        },
        // Progress: {
        //   circleTextColor: isDarkMode ? colors.white : colors.black
        // },
      },
    }}>
      <div className={getTheme()}>
        {contextHolder}
        {children}
      </div>
    </ConfigProvider>
  );
};

export default ThemeProvider;
